var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-button"},[_c('div',{staticClass:"input-button__button",on:{"click":_vm.resetFilter}},[_vm._v(_vm._s(_vm.language.code === 'en' ? 'Reset Filter' : 'إعادة الفرز'))])])}
var staticRenderFns = []

export { render, staticRenderFns }